/**
 * 利用ゾーンのバリデーション.
 * 例：jp-kest-00のような形式で入力
 * <jp-k>:固定
 * <eまたはw>:東日本または西日本
 * <st->:固定
 * <00〜99>:ゾーン番号
 * */

export default {
  validate(value: string | undefined | null): boolean {
    if (!value) return true;

    const pattern = /^jp-k(e|w)st-\d{2}$/;

    return pattern.test(value);
  },
};
